import { render, staticRenderFns } from "./MportfacilitiesGrid.vue?vue&type=template&id=ef87a21a"
import script from "./MportfacilitiesGrid.vue?vue&type=script&lang=js"
export * from "./MportfacilitiesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports